import { render, staticRenderFns } from "./subscription-groups.vue?vue&type=template&id=23d43b56"
import script from "./subscription-groups.vue?vue&type=script&lang=js"
export * from "./subscription-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports